module.exports = __webpack_public_path__ + "static/the-most-important-thing-c664880b57180d2cdd2148967b344137.jpg";